import React, { useState } from 'react';
import { Card, Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { Navigate, useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/Loader';
import DivCenter from '../../components/div/DivCenter';
import { AppInfo } from '../../parts/menu/AppInfo';
import pagesActions from '../pagesActions';
import { hasRead } from '../../helpers/jwt';

const logoImage = '/assets/img/logo.png';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState({ isError: false, errorMsg: '' });

  const navigate = useNavigate();

  const validateForm = () => email.length > 0 && password.length > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    pagesActions.login(email, password, callbackProcess);
    pagesActions.validateUser(navigate);
  };

  const callbackProcess = (data) => {
    if (data.status === 'OK') {
      localStorage.setItem('user_jwt', data.msg.jwtToken);
      localStorage.setItem('user', data.msg.user);
      localStorage.setItem('perms', data.msg.perms);
      setError({ isError: false, errorMsg: '' });
      window.location.replace('/');
    } else {
      setLoader(false);
      setError({ isError: true, errorMsg: data.msg });
    }
  };


  return (
    <>
      <Loader loader={loader} setLoader={setLoader} />
      <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <Row className="w-100 justify-content-center">
          <Col xs={12} sm={10} md={4} lg={3}>
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <div className="text-center mb-4">
                  <img src={logoImage} alt="Logo" height={60} />
                  <h5 className="fw-bold mt-3">Zaloguj się</h5>
                </div>

                {error.isError && (
                  <Alert variant="danger" className="text-center">
                    <strong>{error.errorMsg?.message || 'Wystąpił nieznany błąd.'}</strong>
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="username">
                    <Form.Control
                      type="text"
                      placeholder="Login"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="loginPassword">
                    <Form.Control
                      type="password"
                      placeholder="Hasło"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <DivCenter>
                    <Button type="submit" variant="primary" className="w-100" disabled={!validateForm()}>
                      Zaloguj się
                    </Button>
                  </DivCenter>
                </Form>
              </Card.Body>

              <Card.Footer className="text-center bg-white border-0 mt-3">
                <DivCenter>

                  <AppInfo fixed={false} />
                </DivCenter>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LoginPage;
